export default "__VITE_ASSET__CaHXpVxu__"